// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3ba8bcf7","453":"1cd9952f","580":"f062297f","756":"5141f6ef"}[chunkId] + ".chunk.js";
};